import { useEffect, useState } from 'react';

export type RetentionNotice = {
  lastActivityAt: string;
  warnAt: string;
  purgeAt: string;
};

export function ChatRetentionNotice({
  notice,
  latestActivityAt,
  now,
}: {
  notice?: RetentionNotice | null | undefined;
  latestActivityAt?: string | undefined;
  now?: number | undefined;
}) {
  const [clock, setClock] = useState(() => Date.now());
  useEffect(() => {
    if (!notice || now !== undefined) return;
    // Local time only: no periodic API/database requests for this notice.
    const timer = setInterval(() => setClock(Date.now()), 60_000);
    return () => clearInterval(timer);
  }, [notice, now]);
  if (!notice) return null;
  const warning = Date.parse(notice.warnAt);
  const deadline = Date.parse(notice.purgeAt);
  const activity = Date.parse(notice.lastActivityAt);
  const current = now ?? clock;
  if (![warning, deadline, activity].every(Number.isFinite) || current < warning) return null;
  // A durable new item may arrive before the detail-query refresh. Optimistic items
  // are excluded by the caller: an unsuccessful send does not reset retention.
  if (latestActivityAt && Date.parse(latestActivityAt) > activity) return null;
  const date = new Intl.DateTimeFormat('ru-RU', { timeZone: 'UTC' }).format(deadline);
  return (
    <p className="chat-retention-notice" role="status">
      {current < deadline
        ? `Если беседа останется неактивной, содержимое сообщений и ответов в играх будет очищено начиная с ${date}.`
        : 'Из-за длительной неактивности содержимое сообщений и ответов в играх подлежит очистке.'}{' '}
      Новое сообщение или событие игры до очистки переносит срок. Простое открытие чата его не
      меняет.
    </p>
  );
}
